import { Component } from '@angular/core';

@Component({
    selector: 'app-table-header-sort',
    templateUrl: 'table-header-sort.component.html',
    styleUrls: ['table-header-sort.component.scss'],
    standalone: false
})
export class TableHeaderSortComponent {}
